const getApptSelectedDate = () => {
  const $form = $('form')
  const day = $form.find('.day-select[name="appointment[day(3i)]"]').val()
  const month = $form.find('.day-select[name="appointment[day(2i)]"]').val()
  const year = $form.find('.day-select[name="appointment[day(1i)]"]').val()
  return `${day}-${month}-${year}`
};

$(document).on('ready turbolinks:load', function() {
  const $body = $('body')
  $body.on('change', '.appt-time-radio', function() {
    const timeArr = $(this).val().split(' - ')
    const startTime = timeArr[0]
    const endTime = timeArr[1]
    const startTimeHour = startTime.split(':')[0]
    const startTimeMin = startTime.split(':')[1]
    const endTimeHour = endTime.split(':')[0]
    const endTimeMin = endTime.split(':')[1]

    $(this).closest('form').find('.start-time-field[name="appointment[start_time(4i)]"]').val(startTimeHour).trigger('change')
    $(this).closest('form').find('.start-time-field[name="appointment[start_time(5i)]"]').val(startTimeMin).trigger('change')
    $(this).closest('form').find('.end-time-field[name="appointment[end_time(4i)]"]').val(endTimeHour).trigger('change')
    $(this).closest('form').find('.end-time-field[name="appointment[end_time(5i)]"]').val(endTimeMin).trigger('change')
  });

  $body.on('change', '#appt-client-selector', function() {
    const userId = $(this).closest('.appt-form').attr('data-user-id')
    const url = `/users/${userId}/clients/${$(this).val()}`

    $.ajax({
      url,
      dataType: 'json'
    })
      .done(function({ client }) {
        $('#appt-price-selector').val(client?.appointment_cost)
        $('#appt-currency-selector').val(client?.currency).trigger('change')
        $('#appt-payment-selector').val(client?.default_payment_method).trigger('change')
      });
  });

  $body.on('change', '#appt-modal-user-id-selector', function() {
    const userId = $(this).val()
    const officeId = $('.modal').attr('data-office-id')
    const strDay = getApptSelectedDate()
    const url = `/offices/${officeId}/appointments/admin_new`

    $.ajax({
      url,
      dataType: 'script',
      data: {
        user_id: userId,
        day: strDay
      }
    })
  });

  $body.on('change', '#appt-edit-modal-user-id-selector', function() {
    const userId = $(this).val()
    const officeId = $('.modal').attr('data-office-id')
    const apptId = $('.modal').find('.appt-info').attr('data-appt-id')
    const strDay = getApptSelectedDate()
    const url = `/offices/${officeId}/appointments/${apptId}/admin_edit`

    $.ajax({
      url,
      dataType: 'script',
      data: {
        user_id: userId,
        day: strDay
      }
    })
  });

  $('.client-selector').select2({
    ajax: {
      url: `/users/${$('.client-selector').data('user-id')}/clients`,
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'text/plain'
      },
      type: 'GET',
      delay: 250,
      data: function(params) {
        return {
          'q[name_cont]': params.term,
          page: params.page
        };
      },
      processResults: function(data, params) {
        params.page = params.page || 1;
        const clients = data.map(client => ({ id: client.id, text: client.name }));
        return {
          results: clients,
          pagination: {
            more: params.page * 30 < data.total_count
          }
        };
      },
      cache: true
    },
    width: null,
    minimumResultsForSearch: 1,
  });

  window.updateAppointmentsWithRelations = (hasOverlapping) => {
    const editConditionForm = document.querySelector('#edit_condition_form')
    const editConditionInput = document.querySelector('#edit-condition-input')
    editConditionInput.value = editConditionForm.elements['edit_condition'].value
    hasOverlapping ? checkExistingEvents() : submitModalForm('add-appointment')
  }

  window.checkExistingEvents = () => {
    const officeId = $('#calendar').data('office-id')
    const url = `/offices/${officeId}/appointments/check_google_events`
    const $form = $('form')
    const stH = $form.find('.start-time-field[name="appointment[start_time(4i)]"]').val()
    const stM = $form.find('.start-time-field[name="appointment[start_time(5i)]"]').val()
    const endH = $form.find('.end-time-field[name="appointment[end_time(4i)]"]').val()
    const endM = $form.find('.end-time-field[name="appointment[end_time(5i)]"]').val()
    const startTime = `${stH}:${stM}`
    const endTime = `${endH}:${endM}`
    const strDay = getApptSelectedDate()
    const apptId = $('.appt-info').data('appt-id')

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment: {
          start_time: startTime,
          end_time: endTime,
          day: strDay
        },
        id: apptId
      }
    })
  };

  window.submitModalForm = (modalId) => {
    const $modal = $(`#${modalId}`)
    const form = $modal.find('form')[0];
    preloader.show()
    Rails.fire(form, 'submit');
  }

  $body.on('change', '#appt-day-selector', function(event) {
    const strDay = getApptSelectedDate()
    const apptId = $('.appt-info').data('appt-id')
    const officeId = $('#calendar').data('office-id') || $('#appt-office-selector').val()
    let userId = $('#appt-modal-user-id-selector').val()
    userId = userId || $(this).closest('.appt-form').attr('data-user-id')
    const url = `/offices/${officeId}/suggested_appointment_times/suggested_slots_for_date`

    $.ajax({
      url,
      dataType: 'script',
      data: {
        appointment_id: apptId,
        date: strDay,
        user_id: userId
      }
    })
  });

  $body.on('change', '#currency-type-selector', function(event) {
    $('#display-currency-hidden-input').val($('#currency-type-selector').val())
    const form = $('form.search')[0];
    $(form).find('#submit-btn').click();
  });

  $body.on('click', '.modal__spread__open', function (event) {
    event.preventDefault()
    const { modal } = $(this).data();
    modal === 'delete' ?
      openModal('#spread-delete-appointment-changes') :
      openModal('#spread-edit-appointment-changes')
  })
});

export class DuplicateForm {
  constructor () {
    this.checkboxEl = document.getElementById('template_duplicate')
    this.handleCheckboxChange()
  }

  static closeFormVisibility () {
    const formEl = document.querySelector('.template_selector');
    if (formEl)
      formEl.classList.remove('visible');
  }

  handleCheckboxChange () {
    this.checkboxEl.addEventListener('change', this.toggleFormVisibility)
  }

  toggleFormVisibility () {
    const formEl = document.querySelector('.template_selector')
    formEl.classList.toggle('visible')
  }
}
